import { useAuth } from "./AuthProvider";
import React from 'react';

const Home = () => {
    const { isAuthenticated, user, permissions } = useAuth();

    // Mostrar permisos en consola para debugging
    React.useEffect(() => {
        if (isAuthenticated && permissions) {
            console.log('🔐 Permisos del usuario:', permissions);
        }
    }, [isAuthenticated, permissions]);

    return(
        <div className="home-layout">
            <div className="welcome-text">
                {isAuthenticated && user ? `Bienvenido ${user["usuario"] || user["email"] || 'Usuario'}` : "Bienvenido"}
            </div>
        </div>
    );
}

export default Home;